import { OutlinedComponent } from '@inter-ikea-core/core';
import { SlidingDoorComponent } from '@inter-ikea-storageone/range';
import {
  CustomSlidingDoorComponent,
  CustomizedSlidingDoorComponent,
  PanelArrangement
} from '@inter-ikea-storageone/range-pax';
import { reportAddCustomSlidingDoor } from 'analytics/reporters';
import { BehaviorParameters } from 'rangeConfig/@types';
import autoFillDoorsBehavior from 'rangeConfig/pax/behaviors/autoFillDoors';
import dragAndDropDoorsBehavior from './dragAndDropDoorsBehavior';

const addCustomSlidingDoor = ({ coreApi, rootState, dispatch, props }: BehaviorParameters) => {
  let placementResult;
  if (props.position) {
    placementResult = dragAndDropDoorsBehavior({
      coreApi,
      rootState,
      dispatch,
      props
    });
    if (placementResult.placedEntity) {
      placementResult.placedEntity.addComponent(new CustomSlidingDoorComponent());
      placementResult.placedEntity.addComponent(
        new CustomizedSlidingDoorComponent(PanelArrangement.Columns)
      );
      coreApi.entities.select(placementResult.placedEntity);
    }
  } else {
    autoFillDoorsBehavior([])({
      coreApi,
      rootState,
      dispatch,
      props
    });
    const addedCustomSlidingDoors = coreApi.entities.getByComponent(SlidingDoorComponent.id);
    addedCustomSlidingDoors.forEach(door => {
      door.addComponent(new CustomSlidingDoorComponent());
      door.addComponent(new CustomizedSlidingDoorComponent(PanelArrangement.Columns));
      door.addComponent(new OutlinedComponent());
    });
    coreApi.entities.select(addedCustomSlidingDoors[0]);
  }
  reportAddCustomSlidingDoor();
};

export default addCustomSlidingDoor;
